import { useEffect, useMemo, useState } from "react"
import { Button, FormGroup, Popover } from "react-bootstrap"
import { Check2Circle, Toggles } from "react-bootstrap-icons"
import { changeStatus } from "../store/api/workItemsApi"
import { setErrorDialog } from "../../store/api/CommonFunctions"
import { useDispatch } from "react-redux"

export default function PopWorkItemStatus({ statusList, statusData, onChange }) {
    const dispatch = useDispatch();
    const [currentStatus, setCurrentStatus] = useState();
    const [isPending, setIsPending] = useState(false);
    const handleStatusChange = (e) => {
        setCurrentStatus(e.target.value);
    }
    const handleSumbit = async () => {
        if (!currentStatus || isPending) {
            return;
        }
        const result = await changeStatus(statusData.workItemId, currentStatus);
        if (result?.Message) {
            setErrorDialog(dispatch, result.Message, "تغییر وضعیت", 1000);
        }
        else if (result?.Data) {
            setErrorDialog(dispatch, "success", "تغییر وضعیت", 10000);
            onChange?.(currentStatus);
        }
    }
    const posStyle = useMemo(() => {
        if (statusData?.e) {
            return {
                left: statusData.e.pageX - 20,
                top: statusData.e.pageY - 180
            };
        }
        return { display: "none" };
    }, [statusData]);
    useEffect(()=>{
        setCurrentStatus(statusData?.statusId);
    },[statusData?.statusId])    
    if (!statusData || !statusData.e) return null;

    return   (<Popover id="popover-workItemStatus" style={{ fontSize: "13px", fontFamily: "Vazir", maxWidth: "200px", minWidth: "200px", ...posStyle }}>
        <Popover.Title as="h4" className="headerStyle">
            <Toggles size={18
            } />&nbsp;
            تغییر وضعیت </Popover.Title>
        <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "6px" }}>
            <FormGroup>
                <select className="form-control" onChange={handleStatusChange} value={currentStatus}>
                    <option value="">انتخاب کنید</option>
                    {
                        Array.isArray(statusList) &&
                        statusList
                            .map(
                                (ss, i) =>
                                    <option key={i} value={ss.Id}>{ss.Name}</option>
                            )}
                </select>
            </FormGroup>
            <Button variant="success" className="group-Btn-smalll mt-2" onClick={handleSumbit}><Check2Circle size={18} />&nbsp; ثبت وضعیت</Button>
        </Popover.Content>
    </Popover>)

}